import { motion } from "framer-motion";
import { SealCheck } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import { SITE, IMAGES } from "@/constants/site";

const STATS = [
  { value: "1,200+", label: "families advised" },
  { value: "15+", label: "years of experience" },
  { value: "20+", label: "insurer & banking partners" },
];

export const About = () => (
  <section id="about" className="py-24 md:py-32 bg-sage" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-forest/15">
            <img src={IMAGES.advisor} alt="Krishna Menon, Founder & Advisor — Kris Fin Care" loading="lazy"
              className="w-full h-[480px] object-cover object-top" data-testid="about-image" />
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="absolute -bottom-6 -right-4 md:-right-8 bg-white border border-black/5 rounded-2xl px-5 py-4 shadow-xl shadow-forest/10 flex items-center gap-3"
          >
            <SealCheck size={28} weight="fill" className="text-mint" />
            <div>
              <p className="text-sm font-bold text-ink">Independent advice</p>
              <p className="text-xs text-moss">Your interest, always first</p>
            </div>
          </motion.div>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-mint">About {SITE.brand}</p>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink text-balance">
            One advisor for your cover, your home and your future
          </h2>
          <p className="mt-6 text-base sm:text-lg text-moss leading-relaxed max-w-2xl">
            {SITE.brand} helps individuals, families and businesses choose the right medical,
            life, motor and pension cover — and arranges home and commercial property loans
            through associations with all major banks and NBFCs. We earn your trust the
            old-fashioned way: honest comparisons, transparent terms and support long after
            the paperwork is signed.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-3 gap-6">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.1 + i * 0.1}>
              <div className="border-l-2 border-mint pl-4">
                <p className="font-serif text-3xl md:text-4xl text-forest">{s.value}</p>
                <p className="mt-1 text-xs md:text-sm text-moss tracking-wide">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.4}>
          <p className="mt-10 font-serif italic text-xl text-forest">— Krishna Menon, Founder &amp; Advisor</p>
        </Reveal>
      </div>
    </div>
  </section>
);
